// extracted by mini-css-extract-plugin
export default {"tabContainer":"Tabs-module__tabContainer--FWG7a","tabList":"Tabs-module__tabList--CaXez","tabPanel":"Tabs-module__tabPanel--uCOpK"};